import { useTranslation } from 'react-i18next';
import { Info, Plus } from 'assets/icons';
import { useStore } from 'stores';
import Box from './Box';
import { getUserMarketProfile, addUserMarketProfile } from 'api/strategy';
import { formatStockName } from 'utils/stock';

/** 從陣列中抓出要的值 */
const profitIndex = {
  date: 0,
  openingPrice: 1 /** 開盤價 */,
  highestPrice: 2 /** 最高價 */,
  lowestPrice: 3 /** 最低價 */,
  closingPrice: 4 /** 收盤價 */,
  volume: 7 /** 交易量 */,
  position: 8 /** 部位 */,
  income: 9 /** 損益 */,
};

export default function Stock() {
  const { t } = useTranslation();
  const currentStock = useStore((state) => state.currentStock); /** 股票代號 */
  const strategyList = useStore((state) => state.strategyList); /** 策略清單 */
  const UserAiSMProfit = useStore((state) => state.UserAiSMProfit); /** 開盤價那些的 */
  const currentSeriesIndex = useStore((state) => state.currentSeriesIndex);
  const targetProfit = UserAiSMProfit ? UserAiSMProfit[currentSeriesIndex] : null;
  const currentEmail = useStore((state) => state.currentEmail); /** 登入者的信箱 */
  const currentStrategy = useStore((state) => state.currentStrategy); /** 現在選的策略 */
  const setUserMarketProfile = useStore((state) => state.setUserMarketProfile);

  /** 取得價格顏色 */
  function getPriceColor(profit, idx) {
    if (!profit) {
      return;
    }
    const openingPrice = Number(profit[profitIndex.openingPrice]);
    const targetPrice = Number(profit[idx]);
    if (openingPrice > targetPrice) {
      return 'green';
    } else if (openingPrice === targetPrice) {
      return 'gray';
    } else {
      return 'red';
    }
  }

  /** 取得損益顏色 */
  function getIncomeColor(income) {
    if (!income) {
      return;
    }

    const number = Number(income);

    if (number < 0) {
      return 'green';
    } else if (number === 0) {
      return 'gray';
    } else {
      return 'red';
    }
  }

  async function handlePlusClick() {
    /** 新增自選 */
    const res = await addUserMarketProfile(
      currentEmail,
      currentStock.marketId,
      currentStrategy.StrategyProfileId
    );
    if (res) {
      const newUserMarketProfile = await getUserMarketProfile(currentEmail);
      setUserMarketProfile(newUserMarketProfile);
    }
  }

  return (
    <div className="bg-sky-light p-4">
      <div className="flex items-center px-2 pb-4">
        <div className="text-2xl text-blue font-semibold flex-1">
          {formatStockName(currentStock)}
        </div>
        <div className="px-2 xs:px-4">
          <div className="text-gray font-semibold flex-1 flex items-center text-sm xs:text-base">
            <Info className="w-4 h-4 xs:w-6 xs:h-6" />
            {strategyList?.find(
              ({ StrategyProfileId }) => StrategyProfileId === currentStrategy.StrategyProfileId
            )?.ProfileName || '-'}
          </div>
          <div className="text-gray text-sm xs:text-base">
            {targetProfit ? targetProfit[0] : '-'}
          </div>
        </div>
        <button className="text-3xl text-blue border border-blue rounded-lg p-1">
          <Plus onClick={handlePlusClick} />
        </button>
      </div>
      <div className="flex flex-wrap">
        <Box
          title={t('Stock.openingPrice')}
          content={targetProfit ? targetProfit[profitIndex.openingPrice] : '-'}
          color={getPriceColor(targetProfit, profitIndex.openingPrice)}
        />
        <Box
          title={t('Stock.closingPrice')}
          content={targetProfit ? targetProfit[profitIndex.closingPrice] : '-'}
          color={getPriceColor(targetProfit, profitIndex.closingPrice)}
        />
        <Box
          title={t('Stock.highestPrice')}
          content={targetProfit ? targetProfit[profitIndex.highestPrice] : '-'}
          color={getPriceColor(targetProfit, profitIndex.highestPrice)}
        />
        <Box
          title={t('Stock.lowestPrice')}
          content={targetProfit ? targetProfit[profitIndex.lowestPrice] : '-'}
          color={getPriceColor(targetProfit, profitIndex.lowestPrice)}
        />
        <Box
          title={t('Stock.position')}
          content={targetProfit ? targetProfit[profitIndex.position] : '-'}
          unit={t('Stock.lot')}
        />
        <Box
          title={t('Stock.income')}
          content={targetProfit ? targetProfit[profitIndex.income] : '-'}
          color={getIncomeColor(targetProfit ? targetProfit[profitIndex.income] : null)}
          unit={t('Stock.point')}
        />
      </div>
    </div>
  );
}
